<!--<template>-->
    <!--<div>-->
        <!--<div v-if="options_loaded && passed_filter">-->
            <!--<template v-if="filtered_option_list.length > 0 && filtered_option_list[0].value !== null">-->
                <!--<div class="designeroption" :data-designer-component-id="component_id">-->
                    <!--<h3>{{ title }}</h3>-->
                    <!--<div class="stylesoption selectoption form-group">-->
                        <!--<select :id="'question&#45;&#45;' + component_id" class="form-control" v-model="localTarget" v-if="!loading">-->
                            <!--<option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>-->
                        <!--</select>-->
                        <!--<select :id="'question&#45;&#45;' + component_id" disabled class="form-control" v-if="loading">-->
                            <!--<option>Loading Options...</option>-->
                        <!--</select>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</template>-->
        <!--</div>-->
    <!--</div>-->
<!--</template>-->

<script type="text/ecmascript-6">
    import DesignerQuestionHardwareCylinderStable from "../DesignerQuestionHardwareCylinderStable.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareCylinderStable,
            TileQuestion
        ],
        computed: {
            thumbURL(){
                return '/thumb/hardware/';
            },
        }
    }
</script>
